export default "__VITE_ASSET__DLdqYxLy__"